// package: Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1
// file: inv_non_serialized_inventory_service.proto

var inv_non_serialized_inventory_service_pb = require("./inv_non_serialized_inventory_service_pb");
var google_protobuf_empty_pb = require("google-protobuf/google/protobuf/empty_pb");
var inv_common_message_pb = require("./inv_common_message_pb");
var inv_non_serialized_inventory_message_pb = require("./inv_non_serialized_inventory_message_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var NonSerializedInventoryService = (function () {
  function NonSerializedInventoryService() {}
  NonSerializedInventoryService.serviceName = "Olameter.WFMS.InventoryManagement.NonSerializedInventory.v1.NonSerializedInventoryService";
  return NonSerializedInventoryService;
}());

NonSerializedInventoryService.Healthz = {
  methodName: "Healthz",
  service: NonSerializedInventoryService,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: inv_common_message_pb.HealthzResponse
};

NonSerializedInventoryService.GetAll = {
  methodName: "GetAll",
  service: NonSerializedInventoryService,
  requestStream: false,
  responseStream: false,
  requestType: google_protobuf_empty_pb.Empty,
  responseType: inv_non_serialized_inventory_service_pb.NonSerializedInventoryListResponse
};

NonSerializedInventoryService.GetListByContract = {
  methodName: "GetListByContract",
  service: NonSerializedInventoryService,
  requestStream: false,
  responseStream: false,
  requestType: inv_non_serialized_inventory_service_pb.GetListByContractRequest,
  responseType: inv_non_serialized_inventory_service_pb.NonSerializedInventoryListResponse
};

NonSerializedInventoryService.GetList = {
  methodName: "GetList",
  service: NonSerializedInventoryService,
  requestStream: false,
  responseStream: false,
  requestType: inv_non_serialized_inventory_service_pb.GetNonSerializedInventoryListRequest,
  responseType: inv_non_serialized_inventory_service_pb.NonSerializedInventoryDataSourceResponse
};

NonSerializedInventoryService.GetByName = {
  methodName: "GetByName",
  service: NonSerializedInventoryService,
  requestStream: false,
  responseStream: false,
  requestType: inv_non_serialized_inventory_service_pb.GetNonSerializedInventoryByNameRequest,
  responseType: inv_non_serialized_inventory_service_pb.NonSerializedInventoryResponse
};

NonSerializedInventoryService.Create = {
  methodName: "Create",
  service: NonSerializedInventoryService,
  requestStream: false,
  responseStream: false,
  requestType: inv_non_serialized_inventory_service_pb.NonSerializedInventoryRequest,
  responseType: inv_non_serialized_inventory_service_pb.NonSerializedInventoryResponse
};

NonSerializedInventoryService.Update = {
  methodName: "Update",
  service: NonSerializedInventoryService,
  requestStream: false,
  responseStream: false,
  requestType: inv_non_serialized_inventory_service_pb.NonSerializedInventoryRequest,
  responseType: inv_non_serialized_inventory_service_pb.NonSerializedInventoryResponse
};

NonSerializedInventoryService.Transfer = {
  methodName: "Transfer",
  service: NonSerializedInventoryService,
  requestStream: false,
  responseStream: false,
  requestType: inv_non_serialized_inventory_service_pb.NonSerializedInventoryTransferRequest,
  responseType: inv_non_serialized_inventory_service_pb.NonSerializedInventoryListResponse
};

NonSerializedInventoryService.Adjust = {
  methodName: "Adjust",
  service: NonSerializedInventoryService,
  requestStream: false,
  responseStream: false,
  requestType: inv_non_serialized_inventory_service_pb.NonSerializedInventoryAdjustRequest,
  responseType: inv_non_serialized_inventory_service_pb.NonSerializedInventoryResponse
};

NonSerializedInventoryService.Delete = {
  methodName: "Delete",
  service: NonSerializedInventoryService,
  requestStream: false,
  responseStream: false,
  requestType: inv_non_serialized_inventory_service_pb.NonSerializedInventoryRequest,
  responseType: inv_non_serialized_inventory_service_pb.NonSerializedInventoryResponse
};

NonSerializedInventoryService.GetLocationsByInventoryId = {
  methodName: "GetLocationsByInventoryId",
  service: NonSerializedInventoryService,
  requestStream: false,
  responseStream: false,
  requestType: inv_non_serialized_inventory_message_pb.GetByNonSerializedInventoryIdRequest,
  responseType: inv_non_serialized_inventory_message_pb.NonSerializedInventoryLocationListResponse
};

NonSerializedInventoryService.GetLocationsByLocationId = {
  methodName: "GetLocationsByLocationId",
  service: NonSerializedInventoryService,
  requestStream: false,
  responseStream: false,
  requestType: inv_non_serialized_inventory_message_pb.GetByLocationIdRequest,
  responseType: inv_non_serialized_inventory_message_pb.NonSerializedInventoryLocationListResponse
};

NonSerializedInventoryService.AddOrUpdateQuantity = {
  methodName: "AddOrUpdateQuantity",
  service: NonSerializedInventoryService,
  requestStream: false,
  responseStream: false,
  requestType: inv_non_serialized_inventory_message_pb.AddOrUpdateQuantityRequest,
  responseType: inv_non_serialized_inventory_message_pb.NonSerializedInventoryLocationResponse
};

NonSerializedInventoryService.GetAdjustmentNotes = {
  methodName: "GetAdjustmentNotes",
  service: NonSerializedInventoryService,
  requestStream: false,
  responseStream: false,
  requestType: inv_non_serialized_inventory_service_pb.GetNonSerializedInventoryByNameRequest,
  responseType: inv_non_serialized_inventory_service_pb.AdjustmentNoteListResponse
};

NonSerializedInventoryService.GetLowStockWarnings = {
  methodName: "GetLowStockWarnings",
  service: NonSerializedInventoryService,
  requestStream: false,
  responseStream: false,
  requestType: inv_non_serialized_inventory_service_pb.GetLowStockWarningsRequest,
  responseType: inv_non_serialized_inventory_service_pb.GetLowStockWarningsResponse
};

exports.NonSerializedInventoryService = NonSerializedInventoryService;

function NonSerializedInventoryServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

NonSerializedInventoryServiceClient.prototype.healthz = function healthz(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NonSerializedInventoryService.Healthz, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NonSerializedInventoryServiceClient.prototype.getAll = function getAll(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NonSerializedInventoryService.GetAll, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NonSerializedInventoryServiceClient.prototype.getListByContract = function getListByContract(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NonSerializedInventoryService.GetListByContract, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NonSerializedInventoryServiceClient.prototype.getList = function getList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NonSerializedInventoryService.GetList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NonSerializedInventoryServiceClient.prototype.getByName = function getByName(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NonSerializedInventoryService.GetByName, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NonSerializedInventoryServiceClient.prototype.create = function create(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NonSerializedInventoryService.Create, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NonSerializedInventoryServiceClient.prototype.update = function update(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NonSerializedInventoryService.Update, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NonSerializedInventoryServiceClient.prototype.transfer = function transfer(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NonSerializedInventoryService.Transfer, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NonSerializedInventoryServiceClient.prototype.adjust = function adjust(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NonSerializedInventoryService.Adjust, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NonSerializedInventoryServiceClient.prototype.delete = function pb_delete(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NonSerializedInventoryService.Delete, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NonSerializedInventoryServiceClient.prototype.getLocationsByInventoryId = function getLocationsByInventoryId(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NonSerializedInventoryService.GetLocationsByInventoryId, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NonSerializedInventoryServiceClient.prototype.getLocationsByLocationId = function getLocationsByLocationId(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NonSerializedInventoryService.GetLocationsByLocationId, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NonSerializedInventoryServiceClient.prototype.addOrUpdateQuantity = function addOrUpdateQuantity(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NonSerializedInventoryService.AddOrUpdateQuantity, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NonSerializedInventoryServiceClient.prototype.getAdjustmentNotes = function getAdjustmentNotes(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NonSerializedInventoryService.GetAdjustmentNotes, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

NonSerializedInventoryServiceClient.prototype.getLowStockWarnings = function getLowStockWarnings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(NonSerializedInventoryService.GetLowStockWarnings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.NonSerializedInventoryServiceClient = NonSerializedInventoryServiceClient;

